import { Event } from "event-system";

export class CancellationToken {
    public readonly onCanceled: Event<void>;
    private canceled: boolean;
    
    public get isCancellationRequested(): boolean {
        return this.canceled;
    }

    public constructor() {
        this.onCanceled = new Event();
        this.canceled = false;
    }

    public cancel(): void {
        this.canceled = true;
        this.onCanceled.emit();
    }
}